import styled from 'styled-components/macro';

export const VoiceRecorderWrapper = styled.div`
  border-radius: 6px;
  padding: 15px 16px;
  gap: 16px;
  border: ${props => `1px solid ${props.theme.colors.neutral[10]}`};
  box-shadow:
    0px 4px 8px 0px rgba(66, 79, 104, 0.03),
    0px 0px 2px 0px rgba(66, 79, 104, 0.08);
`;
